<template>
  <div>
    <vs-dropdown style="margin-left: 5px; cursor: pointer;" vs-custom-content vs-trigger-click>
      <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

      <vs-dropdown-menu style="min-width: 100px;">
        <vs-dropdown-item v-if="params.colDef.CellRendererParams.checkEditPermission()" @click="params.colDef.CellRendererParams.templateEditSidebar(params.data)">Edit</vs-dropdown-item>
        <vs-dropdown-item v-if="params.colDef.CellRendererParams.checkDeletePermission()" @click="params.colDef.CellRendererParams.templateDeletePopup(params.data)">Delete</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  name: 'TemplateActionCell',
  methods: {
  },
  data() {
    return {}
  }
}
</script>